import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const plans = [
  {
    id: "basic",
    name: "Basic",
    priceLabel: "Free",
    description: [
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      "Nunc congue turpis vel leo pulvinar, ut convallis odio sollicitudin.",
      "Aenean tincidunt nunc sit amet leo consectetur ullamcorper.",
      "In placerat augue vel nulla iaculis, ac ullamcorper risus scelerisque.",
    ],
    highlighted: false,
  },
  {
    id: "standard",
    name: "Standard",
    priceLabel: "£10.75",
    description: [
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      "Nunc congue turpis vel leo pulvinar, ut convallis odio sollicitudin.",
      "Aenean tincidunt nunc sit amet leo consectetur ullamcorper.",
      "In placerat augue vel nulla iaculis, ac ullamcorper risus scelerisque.",
    ],
    highlighted: true,
  },
  {
    id: "premium",
    name: "Premium",
    priceLabel: "£15.55",
    description: [
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      "Nunc congue turpis vel leo pulvinar, ut convallis odio sollicitudin.",
      "Aenean tincidunt nunc sit amet leo consectetur ullamcorper.",
      "In placerat augue vel nulla iaculis, ac ullamcorper risus scelerisque.",
    ],
    highlighted: false,
  },
];

function Subscription({ onOpenAuth, onOpenMenu }) {
  return (
    <div className="min-h-screen bg-slate-100 text-slate-900 flex flex-col">
      <Header onOpenAuth={onOpenAuth} onOpenMenu={onOpenMenu} />

      <main className="mx-auto w-full max-w-7xl flex-1 px-4 py-10 md:px-10">
        <section className="text-center">
          <h1 className="text-2xl font-semibold text-slate-900 md:text-3xl">
            Choose your favorite Package
          </h1>
          <p className="mt-2 text-sm text-slate-500">
            Select one of your favorite package and get the facilities
          </p>
        </section>

        <section className="mt-8 grid gap-6 md:grid-cols-3">
          {plans.map((plan) => (
            <article
              key={plan.id}
              className={`flex flex-col justify-between rounded-2xl border bg-white px-6 py-6 text-left shadow-sm ${
                plan.highlighted
                  ? "border-slate-900 shadow-md"
                  : "border-slate-200"
              }`}
            >
              <div>
                <h2 className="text-xs font-semibold uppercase tracking-[0.12em] text-slate-500">
                  {plan.name}
                </h2>
                <p className="mt-3 text-2xl font-semibold text-slate-900">
                  {plan.priceLabel}
                </p>

                <ul className="mt-4 space-y-2 text-xs text-slate-600">
                  {plan.description.map((line) => (
                    <li key={line} className="flex gap-2">
                      <span className="mt-[5px] h-1.5 w-1.5 rounded-full bg-slate-400" />
                      <span>{line}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <button
                type="button"
                className={`mt-6 w-full rounded-md px-4 py-2 text-xs font-semibold ${
                  plan.highlighted
                    ? "bg-slate-900 text-white"
                    : "bg-slate-200 text-slate-900"
                }`}
              >
                Get Started →
              </button>
            </article>
          ))}
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Subscription;

